/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentContentStatusInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class StudentContentStatusApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'StudentContentStatuses');
  }

  findById(statusId: number): Observable<StudentContentStatusInterface> {
    const path = `${statusId}`;
    return this.get<StudentContentStatusInterface>(path);
  }

  patchAttributes(statusId: number, data: any): Observable<StudentContentStatusInterface> {
    const path = `${statusId}`;
    return this.patch<StudentContentStatusInterface>(path, undefined, data);
  }
}
